import { useNavigate } from "react-router-dom";
import ReplyIcon from "@mui/icons-material/Reply";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useState } from "react";
import {
  Box,
  TextField,
  Button,
} from "@mui/material";

interface User {
  name: string;
  email: string;
  phone: string;
}

interface SupportData {
  id: number;
  question: string;
  answer?: string;
  submittedDate: string;
  status: "Pending" | "Resolved";
  user: User;
}

const ViewQuesAns = () => {
  const navigate = useNavigate();

  const [supportData, setSupportData] = useState<SupportData[]>([
    {
      id: 1,
      question: "Why is my order delayed?",
      submittedDate: "20 Oct 2025",
      status: "Pending",
      user: {
        name: "John Doe",
        email: "john@example.com",
        phone: "+1 555 0123",
      },
    },
    {
      id: 2,
      question: "How to return the product?",
      submittedDate: "18 Oct 2025",
      status: "Resolved",
      answer: "You can return the product using the return center.",
      user: {
        name: "Sarah Wilson",
        email: "sarah@example.com",
        phone: "+91 999 333 2222",
      },
    },
  ]);

  const [replyText, setReplyText] = useState<{ [key: number]: string }>({});

  const handleReplySubmit = (id: number) => {
    if (!replyText[id]) return;

    setSupportData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, answer: replyText[id], status: "Resolved" }
          : item
      )
    );

    setReplyText((prev) => ({ ...prev, [id]: "" }));
  };

  return (
    <>
      <div className="main_title">
        <h1>View Question Answers</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/ques-ans")}>
            Questions and Answers
          </button>{" "}
          - View Question Answers
        </p>
      </div>

      {/* Product Info Card */}
      <div className="cards">
        <div className="view_page">
          <div className="gap_p">
            <div className="w_33">
              <h6>Product ID</h6>
              <p><strong>#PROD-001</strong></p>
            </div>
            <div className="w_33">
              <h6>Product Name</h6>
              <p>Men Sports Shoes</p>
            </div>
            <div className="w_33">
              <h6>Product Category</h6>
              <p>Footwear</p>
            </div>
            <div className="w_33">
              <h6>Product Sub-Category</h6>
              <p>Shoes</p>
            </div>
          </div>
        </div>
      </div>

      <h3>Customer Questions</h3>

      {/* Card List */}
      <div className="cards mt_20">
        {supportData.map((item) => (
          <div key={item.id} className="qa_card">

            {/* USER LINE */}
            <div className="qa_user_row">
              <AccountCircleIcon className="qa_user_icon" />
              <div>
                <strong>{item.user.name}</strong>
                <p className="qa_date">{item.submittedDate}</p>
              </div>
            </div>

            {/* QUESTION */}
            <div className="qa_question">
              <p>{item.question}</p>
            </div>

            {/* ANSWER IF RESOLVED */}
            {item.status === "Resolved" && (
              <div className="qa_answer">
                <label> Answer:</label>
                <p>{item.answer}</p>
              </div>
            )}

            {/* REPLY INPUT IF PENDING */}
            {item.status === "Pending" && (
              <div className="qa_reply_box">
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  placeholder="Type your reply..."
                  value={replyText[item.id] || ""}
                  onChange={(e) =>
                    setReplyText((prev) => ({
                      ...prev,
                      [item.id]: e.target.value,
                    }))
                  }
                />

                <Button
                  variant="contained"
                  className="mt_20 btn"
                  onClick={() => handleReplySubmit(item.id)}
                  startIcon={<ReplyIcon />}
                >
                  Submit Reply
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ViewQuesAns;
